import { call, put, takeLatest } from "redux-saga/effects";
import {
  GET_VPP_TEMPLATES,
  SET_VPP_TEMPLATES,
  GET_NIC_IP_MODES,
  SET_NIC_IP_MODES,
  GET_OS_LIST,
  SET_OS_LIST,
  GET_VM_DETAILS,
  SET_VM_DETAILS,
  GET_OS_VERSIONS,
  SET_OS_VERSIONS,
  PUBLISH_COURSE_DEFINITION,
  SAVE_UPDATE_COURSE_DEFINITION,
  SAVE_UPDATE_COURSE_DEF_SUCCESS,
  SAVE_UPDATE_COURSE_DEF_ERROR,
  GET_COURSE_DATA_BY_ID,
  GET_COURSE_DATA_BY_ID_SUCCESS,
  GET_NIC_NETWORK,
  SET_NIC_NETWORK,
  GET_NIC_NETWORK_ADAPTER_TYPES,
  SET_NIC_NETWORK_ADAPTER_TYPES,
  GET_ALL_VAPP_TEMPLATES_AND_VMS,
  SET_ALL_VAPP_TEMPLATES_AND_VMS,
  GET_COURSE_DATA_BY_ID_FAILURE,
} from "../utils/constants";
import {
  getvAppTemplatesAPI,
  getVmDetailsAPI,
  saveCourseDefinitionAPI,
  updateCourseDefinitionAPI,
  publishCourseDefinitionAPI,
  getCourseDataByIdAPI,
  getOSListApi,
  getOSVersionsApi,
  getNicNetworkApi,
  getNicNetworkAdapterTypeApi,
  getNicIpModesApi,
  getVappTemplatesAndVmDetailsAPI,
} from "./create-course.service";
import { hideLoader, showLoader } from "../../store/model/model.action";
import { AxiosResponse } from "axios";

export function* fetchVAppTemplates(requestParam: {
  type: string;
  payload: string;
}): any {
  try {
    const response = yield call(getvAppTemplatesAPI, requestParam);
    const templates = response.data.map((template: any) => ({
      name: template.vAppTemplateName,
      id: template.hrefVappTemplateId,
    }));
    yield put({ type: SET_VPP_TEMPLATES, response: templates });
  } catch (error) {}
}

export function* fetchOsTypes(requestParam: { type: string; payload: any }) {
  try {
    const resultData: AxiosResponse<any> = yield call(
      getOSListApi,
      requestParam.payload
    );
    if (resultData.status === 200 && resultData.data) {
      yield put({ type: SET_OS_LIST, response: resultData.data });
    } else {
      yield put({ type: SET_OS_LIST, response: [] });
    }
  } catch (error) {
    yield put({ type: SET_OS_LIST, response: [] });
  }
}

export function* fetchOsVersions(requestParam: { type: string; payload: any }) {
  try {
    const resultData: AxiosResponse<any> = yield call(
      getOSVersionsApi,
      requestParam
    );
    if (resultData.status === 200 && resultData.data) {
      yield put({ type: SET_OS_VERSIONS, response: resultData.data });
    } else {
      yield put({ type: SET_OS_VERSIONS, response: [] });
    }
  } catch (error) {
    yield put({ type: SET_OS_VERSIONS, response: [] });
  }
}

export function* fetchNicNetwork(requestParam: { type: string; payload: any }) {
  try {
    const resultData: AxiosResponse<any> = yield call(
      getNicNetworkApi,
      requestParam.payload
    );
    if (resultData.status === 200 && resultData.data) {
      yield put({ type: SET_NIC_NETWORK, response: resultData.data });
    } else {
      yield put({ type: SET_NIC_NETWORK, response: [] });
    }
  } catch (error) {
    yield put({ type: SET_NIC_NETWORK, response: [] });
  }
}

export function* fetchNicIpModes(requestParam: { type: string; payload: any }) {
  try {
    const resultData: AxiosResponse<any> = yield call(
      getNicIpModesApi,
      requestParam.payload
    );
    if (resultData.status === 200 && resultData.data) {
      yield put({ type: SET_NIC_IP_MODES, response: resultData.data });
    } else {
      yield put({ type: SET_NIC_IP_MODES, response: [] });
    }
  } catch (error) {
    yield put({ type: SET_NIC_IP_MODES, response: [] });
  }
}

export function* fetchNicNetworkAdapter(requestParam: {
  type: string;
  payload: any;
}) {
  try {
    const resultData: AxiosResponse<any> = yield call(
      getNicNetworkAdapterTypeApi,
      requestParam.payload
    );
    if (resultData.status === 200 && resultData.data) {
      yield put({
        type: SET_NIC_NETWORK_ADAPTER_TYPES,
        response: resultData.data,
      });
    } else {
      yield put({ type: SET_NIC_NETWORK_ADAPTER_TYPES, response: [] });
    }
  } catch (error) {
    yield put({ type: SET_NIC_NETWORK_ADAPTER_TYPES, response: [] });
  }
}

export function* fetchVmDetails(requestParam: {
  type: string;
  payload: any;
}): any {
  try {
    const response = yield call(getVmDetailsAPI, requestParam);
    if (response.status === 200 && response.data !== null) {
      yield put({ type: SET_VM_DETAILS, response: response.data });
    } else {
      yield put({ type: SET_VM_DETAILS, response: [] });
    }
  } catch (error) {
    yield put({ type: SET_VM_DETAILS, response: [] });
  }
}

export function* fetchvAppTemplatesAndVms(requestParam: {
  type: string;
  payload: any;
}): any {
  try {
    const response = yield call(getVappTemplatesAndVmDetailsAPI, requestParam);
    if (response.status === 200 && response.data) {
      yield put({
        type: SET_ALL_VAPP_TEMPLATES_AND_VMS,
        response: response.data,
      });
    } else {
      yield put({ type: SET_ALL_VAPP_TEMPLATES_AND_VMS, response: [] });
    }
  } catch (error) {}
}

export function* saveCourseDefinition(requestParam: {
  type: string;
  payload: any;
  editMode: boolean;
}): any {
  try {
    yield put(
      showLoader(
        requestParam.editMode
          ? "Updating course environment"
          : "Creating course environment"
      )
    );
    let response = null;
    if (requestParam.editMode) {
      response = yield call(updateCourseDefinitionAPI, requestParam);
    } else {
      response = yield call(saveCourseDefinitionAPI, requestParam);
    }
    console.log("response", response);
    if (response !== undefined && response.status === 200 && response.data) {
      yield put({
        type: SAVE_UPDATE_COURSE_DEF_SUCCESS,
        response: requestParam.payload.CourseName,
      });
      yield put(hideLoader());
    } else if (response.status === 400) {
      yield put({
        type: SAVE_UPDATE_COURSE_DEF_ERROR,
        response:
          response.response.data || "Something went wrong. Please try again",
      });

      yield put(hideLoader());
    } else {
      yield put({
        type: SAVE_UPDATE_COURSE_DEF_ERROR,
        response: "Something went wrong. Please try again",
      });
      yield put(hideLoader());
    }
  } catch (error: any) {
    console.log("error", error);
    if (
      error.response &&
      error.response.status === 400 &&
      error.response.data?.errors.length
    ) {
      const errorMessage =
        error.response.data?.errors[0] ||
        `The Course name \`${requestParam.payload.CourseName}\` already exists. Please use a different course name.`;
      yield put({ type: SAVE_UPDATE_COURSE_DEF_ERROR, response: errorMessage });
      yield put(hideLoader());
    } else {
      yield put({
        type: SAVE_UPDATE_COURSE_DEF_ERROR,
        response:
          error.response?.data || "Something went wrong. Please try again",
      });
      yield put(hideLoader());
    }
  }
}

export function* publishCourseDefinition(requestParam: {
  type: string;
  payload: any;
}): any {
  try {
    yield put(showLoader("Publishing course environment"));
    const response = yield call(publishCourseDefinitionAPI, requestParam);

    if (
      response !== undefined &&
      response.status === 200 &&
      response.data?.message
    ) {
      yield put({
        type: SAVE_UPDATE_COURSE_DEF_SUCCESS,
        response: response.data.message,
      });
      yield put(hideLoader());
    } else if (response !== undefined && response.status === 409) {
      yield put({
        type: SAVE_UPDATE_COURSE_DEF_ERROR,
        response: response.data?.message || "Template name already exists.",
      });
      yield put(hideLoader());
    } else {
      yield put({
        type: SAVE_UPDATE_COURSE_DEF_ERROR,
        response: "Something went wrong. Please try again",
      });
      yield put(hideLoader());
    }
  } catch (error: any) {
    if (error.response && error.response.status === 409) {
      const errorMessage =
        error.response.data?.message || "Template name already exists.";
      yield put({ type: SAVE_UPDATE_COURSE_DEF_ERROR, response: errorMessage });
      yield put(hideLoader());
    } else {
      yield put({
        type: SAVE_UPDATE_COURSE_DEF_ERROR,
        response:
          error.response?.data?.message ||
          "Something went wrong. Please try again",
      });
      yield put(hideLoader());
    }
  }
}
const formattedCourseData = (
  course: any,
  osVersionsMap: { [key: string]: any[] } = {}
) => {
  const vmDetailsArray = Object.keys(course.vmDetails).map((key) => {
    const vm = course.vmDetails[key];
    const extractRamInfo = (ramString: string) => {
      if (!ramString) return { value: "", unit: "" };
      // Use regex to separate numeric value and unit
      const match = ramString.match(/^(\d+)([A-Za-z]+)$/);
      if (match) {
        return {
          value: match[1],
          unit: match[2],
        };
      }
      return { value: ramString, unit: "" };
    };
    const extractCpuValue = (cpuString: string) => {
      if (!cpuString) return "";
      // Extract number from formats like "3cores", "5core", "2 cores", etc.
      const match = cpuString.toString().match(/^(\d+)/);
      return match ? match[1] : cpuString;
    };
    const getStorageValue = (storageString: string) => {
      if (!storageString) return "";
      // Extract only the numeric part from "500 GB" -> "500"
      return storageString.replace(/[^0-9.]/g, "");
    };
    const ramInfo = extractRamInfo(vm.ram);
    const nicConfigArray = vm.niCs
      ? Object.keys(vm.niCs).map((nicKey) => {
          const nic = vm.niCs[nicKey];
          return {
            NICId: nic.niCid,
            IsPrimary: nic.isPrimary,
            IsConnected: nic.isConnected,
            NetworkId: nic.networkID,
            MACId: nic.maCid,
            NetworkAdapterTypeId: nic.networkAdapterTypeID,
            IPModeId: nic.ipModeID,
            ipAddress: nic.iPv4,
            IPV4: "IPV4",
          };
        })
      : [];
    return {
      originalvAppTemplateID: vm.originalvAppTemplateID,
      id: vm.vmID,
      vmID: vm.vmID, // Check
      vmName: vm.vmName,
      vmURL: vm.vmUrl,
      osType: vm.osType,
      osVersion: vm.osVersionName, // Display name
      osVersionValue: vm.osVer, // Original value
      ramUnit: ramInfo.unit,
      ram: ramInfo.value,
      storage: getStorageValue(vm.storage),
      cpu: extractCpuValue(vm.cpu),
      ipAddress: vm.iPv4,
      vmPause: vm.isPausable === "true" ? "Yes" : "No",
      osVersionID: vm.osVersionID,
      bootImage: vm.bootImageId,
      bootImageName: vm.bootImageName,
      bootSetup: vm.bootSetup,
      vmDescription: vm.vmDescription,
      powerOn: vm.isPowerOn,
      vcdVmID: vm.vcdVmID,
      nicConfig: nicConfigArray,
    };
  });

  return {
    /**  START- SETTING GENERAL DETAILS */
    id: course.courseDefintionID,
    courseName: course.courseOrgName,
    courseDescription: course.courseDescription,
    duration: course.courseDuration,
    vAppTemplate: course.vAppTemplateId,
    vAppTemplateName: course.vAppTemplateName,
    courseStage: course.courseStage,
    lastModifiedBy: course.lastModifiedBy,
    lastModifiedDate: course.lastModifiedDate,
    siteId: course.siteId,
    /**  END- SETTING GENERAL DETAILS */
    vmDetails: vmDetailsArray,
  };
};

export function* getCourseDataById(requestParam: {
  type: string;
  payload: string;
}): any {
  try {
    yield put(showLoader("Loading"));
    const response = yield call(getCourseDataByIdAPI, requestParam);
    if (response && response.status === 200 && response.data) {
      const formattedData = formattedCourseData(response.data);
      yield put({
        type: GET_COURSE_DATA_BY_ID_SUCCESS,
        response: formattedData,
      });
      yield put(hideLoader());
    } else {
      yield put({
        type: GET_COURSE_DATA_BY_ID_FAILURE,
        response:
          "Something went wrong while loading the course information. Please try again.",
      });
      yield put(hideLoader());
    }
  } catch (error) {}
}

export default function* createCourseSaga() {
  yield takeLatest(GET_VPP_TEMPLATES, fetchVAppTemplates);
  yield takeLatest(GET_OS_LIST, fetchOsTypes);
  yield takeLatest(GET_OS_VERSIONS, fetchOsVersions);
  yield takeLatest(GET_VM_DETAILS, fetchVmDetails);
  yield takeLatest(GET_ALL_VAPP_TEMPLATES_AND_VMS, fetchvAppTemplatesAndVms);
  yield takeLatest(GET_NIC_NETWORK, fetchNicNetwork);
  yield takeLatest(GET_NIC_IP_MODES, fetchNicIpModes);
  yield takeLatest(GET_NIC_NETWORK_ADAPTER_TYPES, fetchNicNetworkAdapter);
  yield takeLatest(SAVE_UPDATE_COURSE_DEFINITION, saveCourseDefinition);
  yield takeLatest(GET_COURSE_DATA_BY_ID, getCourseDataById);
  yield takeLatest(PUBLISH_COURSE_DEFINITION, publishCourseDefinition);
}
